export default "__VITE_PUBLIC_ASSET__8c905145__"